<!-- Headline component for lection/question elements in ionic app -->
<div [attr.] *ngIf="(evaluation$ | async)" [hidden]="hidden$ | async" class="ion-text-center question-headline question">
  <span [ngStyle]="{'color':color}"><div [innerHTML]="(showHeadline | async) | sanitizeHtml" class="ion-text-center"></div></span>
</div>
